import React from 'react';
import styled from 'styled-components';

const LogoWrapper = styled.li`
  float: left;
  margin-left: 16px;
`;

const HyperLink = styled.a``;

const Image = styled.img`
  height: 26px;
  max-width: 120px;
`;

const UniversityLogo = ({ universityPlan, organizationIdentity }) => {
  if (
    !organizationIdentity?.LogoUrl ||
    !organizationIdentity?.WebsiteUrl ||
    !universityPlan ||
    !universityPlan.code
  )
    return null;
  return (
    <LogoWrapper>
      <HyperLink href={organizationIdentity?.WebsiteUrl} target="_blank">
        <Image src={organizationIdentity?.LogoUrl} />
      </HyperLink>
    </LogoWrapper>
  );
};

export default UniversityLogo;
